import { FormErrors } from '@openx/components-core/lib/FormErrors/FormErrors';

import type { LalSegmentFormState } from '@openx/types/segments';
import { useCallback, useState } from 'react';
import { useLocation } from 'react-router';
import { useInitialValues } from '../hooks/useInitialValues';
import { useSegmentContext } from '../utils/context/SegmentContext';
import { mapFormStateToCreateLookalike } from '../utils/mapFormState';
import { LalSegmentsForm } from './LalSegmentsForm';

export type LalSegmentCreateFormProps = {
  goBack: () => void;
  accountUid: string;
};

export const LalSegmentCreateForm = ({ goBack, accountUid }: LalSegmentCreateFormProps) => {
  const { useCreateLookalikeSegment } = useSegmentContext();
  const { createLookalikeSegment, isCreating } = useCreateLookalikeSegment();

  const [submitErrors] = useState<string[]>([]);
  const [selectedAccountId, setSelectedAccountId] = useState(accountUid);

  const { state } = useLocation();
  const segments = state?.segments ?? [];

  const accountId = segments[0]?.account?.id ?? selectedAccountId;

  const initialValues = useInitialValues(accountId);

  const onCancel = useCallback(() => {
    goBack();
  }, [goBack]);

  const onSubmit = useCallback(
    (values: LalSegmentFormState) => {
      const mappedValues = mapFormStateToCreateLookalike(values);
      createLookalikeSegment(mappedValues);
    },
    [createLookalikeSegment]
  );

  return (
    <>
      <FormErrors errors={submitErrors} />
      <LalSegmentsForm
        goBack={onCancel}
        initialValues={initialValues}
        onSubmit={onSubmit}
        isSubmitting={isCreating}
        setSelectedAccountId={setSelectedAccountId}
      />
    </>
  );
};
